<template>
  <ElDialog
    width="30%"
    :title="$t('APP.TRANSACTIONS.MONTHLY_CSV_EXPORT')"
    :visible="value"
    @close="closeModal"
  >
    <ElForm
      :ref="formRef"
      :rules="rules"
      :model="formModel"
      label-position="top"
    >
      <ElFormItem :label="$t('APP.TRANSACTIONS.SELECT_MONTH_TO_EXPORT')">
        <MonthSelector
          :calendar-type.sync="calendarType"
          :selected-date.sync="selectedDate"
          :default-date="currentMonth"
          :format="dateFormat"
        />
      </ElFormItem>

      <ElFormItem :label="$t('APP.TRANSACTIONS.TRANSACTION_TYPE')">
        <ElRadio v-model="transactionType" label="non_subscription_purchases">
          {{ $t('APP.TRANSACTIONS.PURCHASES_TRANSACTIONS') }}
        </ElRadio>

        <ElRadio
          v-model="transactionType"
          label="non_subscription_purchases_refund"
        >
          {{ $t('APP.TRANSACTIONS.REFUND') }}
        </ElRadio>
      </ElFormItem>

      <ElFormItem :label="$t('EMAIL')" prop="email">
        <ElInput
          v-model="formModel.email"
          class="text-latin"
          type="email"
          name="email"
          dir="ltr"
          required
        />
      </ElFormItem>
    </ElForm>
    <template #footer>
      <ElButton
        type="primary"
        size="medium"
        :loading="loading"
        @click="validateAndSendEmail"
      >
        <i v-show="!loading" class="material-icons">email</i>
        {{ $t('APP.TRANSACTIONS.SEND_TO_EMAIL') }}
      </ElButton>
      <ElButton type="text" size="medium" @click.native="closeModal">
        {{ $t('CANCEL') }}
      </ElButton>
    </template>
  </ElDialog>
</template>

<script>
import MonthSelector from './MonthSelector';
import { TransactionsApi } from '@/api/api';
import packageName from '@/mixins/packageName';
import { calendars } from '@/constants/date';
import form from '@/mixins/form';
import required from '@/utils/validation-rules/required';
import moment from 'moment-jalaali';

export default {
  name: 'DownloadPurchasesCsvModal',
  components: { MonthSelector },
  mixins: [packageName, form],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      calendarType: calendars.JALALI,
      transactionType: 'non_subscription_purchases',
      selectedDate: null,
      loading: false,
      formModel: {
        email: '',
      },
    };
  },

  computed: {
    dateFormat() {
      return this.calendarType === calendars.JALALI ? 'jYYYY-jMM' : 'YYYY-MM';
    },
    currentMonth() {
      return Date.now();
    },
    rules() {
      return {
        email: {
          ...required(this.$t('INVALID_INPUT_VALUE_EMAIL')),
          type: 'email',
        },
      };
    },
    formRef() {
      return 'csvExportFormRef';
    },
    dateRange() {
      if (this.calendarType === calendars.JALALI) {
        const date = moment(this.selectedDate, 'jYYYY-jMM-jDD');
        const startDate = date.startOf('jMonth').format('YYYY-MM-DD');
        const endDate = date.endOf('jMonth').format('YYYY-MM-DD');
        return { startDate, endDate };
      } else {
        const date = moment(this.selectedDate);
        const startDate = date.startOf('month').format('YYYY-MM-DD');
        const endDate = date.endOf('month').format('YYYY-MM-DD');
        return { startDate, endDate };
      }
    },
  },

  methods: {
    validateAndSendEmail() {
      if (!this.isValid(this.formRef)) return;
      this.sendReportToEmail();
    },

    async sendReportToEmail() {
      this.loading = true;
      try {
        await TransactionsApi.sendTransactionFileToEmail({
          email: this.formModel.email,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          transaction_type: this.transactionType,
          package_name: this.packageName,
        });
        this.$message.success(
          this.$t('APP.TRANSACTIONS.EMAIL_SENT_SUCCESSFULLY'),
        );
        this.closeModal();
      } catch ({ message }) {
        this.$message.error(message);
      } finally {
        this.loading = false;
      }
    },
    updateSelecedDate(date) {
      this.selectedDate = date;
    },

    closeModal() {
      this.$refs[this.formRef]?.resetFields();
      this.$emit('input', false);
    },
  },
};
</script>
